<template>
  <div class="home-banner">
    <b-container>
      <b-row>
        <b-col class="left-side" md>
          <b-img src="../assets/jamesc-profile-pic.png" alt="James Choi profile picture"></b-img>
        </b-col>
        <b-col class="right-side" md>
          <p class="pre-h1">THIS IS ME</p>
          <h1>JAMES CHOI</h1>
          <p class="short-description">
            Software Engineer | Yelp
            <br>
            University of Toronto | Computer Science
            <br>
            Explore my site to learn more about me.
          </p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'HomeBanner'
};
</script>

<style lang="scss" scoped>
.home-banner {
  padding-top: 140px;
  background-color: $lightPurple;

  .right-side {
    h1 {
      font-size: 60px;
      font-weight: bolder;
      margin-bottom: 25px;
    }

    p {
      font-size: 14px;
    }

    .pre-h1 {
      font-weight: bold;
    }

    .short-description {
      color: $darkGrey;
    }
  }
}

@media (max-width: $mediaMdWidth) {
  .home-banner {
    padding-top: 50px;
  }

  .left-side {
    text-align: center;
  }

  .right-side {
    margin-top: 50px;
    padding-bottom: 20px;
  }
}
</style>
